import { connect } from "react-redux";
import PropTypes from "prop-types";
import PremierPromotionalMessage from "../../components/PremierPromotionalMessage/index.jsx";

const PremierPromotionalMessageContainer = ({ assetsUrl, countryCode }) => (
  <PremierPromotionalMessage
    assetsUrl={assetsUrl}
    countryCode={countryCode}
    dateFrom={new Date("26 September 2023 8:00:00 GMT+0100").toDateString()}
    dateUntil={new Date("17 October 2023 8:00:00 GMT+0100").toDateString()}
  />
);

const mapStateToProps = (state) => ({
  assetsUrl: state.Environment.assetsUrl,
  countryCode: state.CountrySelector.countryData.country.code,
});

PremierPromotionalMessageContainer.propTypes = {
  assetsUrl: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(PremierPromotionalMessageContainer);
